import { ReportingService } from './../../../model/services/reporting.service';
import { RoutesChange } from './../../../model/services/routes.service';
import { RoutesService } from 'app/model/services/routes.service';
import { SpatialCoord } from './../../../model/mapping/Pixospatial';
import { Costs } from './../../../types/route-data';
import { Feature } from './../../../model/mapping/drawing/Feature';
import { ConfigAttribute, AttributeOption } from './../../../types/project-config';
import { DataManagerService, FeatureSelection } from './../../../model/services/data-manager.service';
import { CostReportService } from './../../../model/services/cost-report.service';
import { ObjID } from './../../../model/id-manager';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, Input, ElementRef, EventEmitter, Output } from '@angular/core';
import { RoutePart } from 'app/model/mapping/drawing/RouteFeature';
import { Route } from 'app/types/route-data';
import { LngLatBounds, LngLatLike, Map } from 'mapbox-gl';
import { SubMode } from '../reports.component';

export type FeatureDatum = { id: ObjID, value: any };

@Component({
  selector: 'app-report-costs',
  templateUrl: './report-costs.component.html',
  styleUrls: ['./report-costs.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReportCostsComponent implements OnInit {

  public features: Array<any> = [];
  @Output()
  public featuresChange = new EventEmitter<Array<any>>();
  private _route?: Route;
  public routeName: string = '';

  private _suppressJump: boolean = false;

  @Input('route')
  set route(route: Route | undefined) {
    this._route = route;
    this.routeName = this.FormatPath(this._route?.name!, this._route?.parent);
    if (!!this._route) {
      this.features = this.MakeReport();//(this._route, this.mode);
    } else {
      this.features = [];
    }
    this.featuresChange.emit(this.features);
    console.log('costs report - route set:', this._route);
    console.log(this.features);
    this.Refresh();
  }
  get route(): Route | undefined {
    return this._route;
  }
  public mode: SubMode = '*';
  private _ready: boolean = false;
  constructor(
    private cdr: ChangeDetectorRef,
    private rpt: CostReportService,
    private rpts: ReportingService,
    private dataMgr: DataManagerService,
    private domNode: ElementRef<HTMLElement>) { }

  public selectedFeature?: FeatureSelection;
  ngOnInit(): void {
    this._ready = true;
    this.rpts.SetCostsComponent(this);

    RoutesService.onChange.subscribe((changeInfo: RoutesChange) => {
      if (changeInfo.change === 'route-change') {
        if (this.route?.id as number !== changeInfo.route) return;
        this.UpdateMode();
        this.Refresh();
      }
      if (changeInfo.change === 'route-vis-changed') {
        if (this._route) {
          this.features = this.MakeReport();//(this._route, this.mode);
          this.featuresChange.emit(this.features);

          this.Refresh();
        }
      }
    });
    this.dataMgr.onFeatureUpdate.subscribe((selection: FeatureSelection) => {
      this.features = this.features.filter((feature: any) => {
        return !!feature.partId;
      });
      this.featuresChange.emit(this.features);

      this.cdr.markForCheck();
      this.Refresh();

    })
    this.dataMgr.onSelect.subscribe((selection: FeatureSelection) => {
      this.selectedFeature = selection;
      this.cdr.markForCheck();
      this.Refresh();
      if (!this._suppressJump) {
        this.ScrollToView();
      }
      this._suppressJump = false;

    })
  }
  GetLength(): number {
    return this.rpt.lastLength;
  }
  GetRouteID(): any {
    return this._route?.id;
  }
  private _commonChecks: any = {};
  private _nativeChecks: any = {};
  MakeReport(): Array<any> {
    this._commonChecks = {};
    this._nativeChecks = {};
    return this.rpt.MakeReport(this._route!, this.mode);;
  }
  IsPointInCommon(feature: any) {
    if (!this._commonChecks.hasOwnProperty(feature.id)) {
      this._commonChecks[feature.id] = (feature.routes && feature.routes.length && feature.routes.length > 1);
    }
    return this._commonChecks[feature.id];
  }
  IsNativePoint(feature: any) {
    if (this._nativeChecks.hasOwnProperty(feature.id)) {
      return this._nativeChecks[feature.id];
    }
    if (feature.featureId === this.route?.id) {
      this._nativeChecks[feature.id] = true;
      return true;
    }
    if (this.rpt.matchedRoutes[feature.featureId]) {
      this._nativeChecks[feature.id] = true;
      return true;
    }
    if (this.IsPointInCommon(feature)) {
      if (feature.featureId !== this.route?.id) {
        for (const routeId of feature.routes) {
          if (this.rpt.matchedRoutes[routeId]) {
            const route = (this.dataMgr.GetProject()?.idRegistry.Get(routeId)) as Route;
            if (route.feature.visible === true) continue;
            this._nativeChecks[feature.id] = true;
            return true;
          }

        }
        const route = (this.dataMgr.GetProject()?.idRegistry.Get(feature.featureId)) as Route;
        this._nativeChecks[feature.id] = route.feature.visible === false;
        return this._nativeChecks[feature.id];
      }
      this._nativeChecks[feature.id] = false;
      return false;
    }
    this._nativeChecks[feature.id] = true;
    return true;
  }
  GetPointInCommonRoutes(feature: any): Array<{ name: string, id: any }> {
    const names: Array<{ name: string, id: any }> = [];
    for (const routeId of feature.routes) {
      const route = this.dataMgr.GetProject()?.idRegistry.Get(routeId);
      names.push({ name: this.FormatPath(route.name, route?.parent), id: routeId });
    }
    names.sort();
    return names;
  }
  SwitchRoute(routeId: any, feature: any) {
    this.SelectRecord(feature);
    const route = this.dataMgr.GetProject()?.idRegistry.Get(routeId);
    if (!this.selectedFeature) { }
    this.dataMgr.SelectFeature(feature.id, route.feature);
  }
  ScrollToView() {
    const elements = this.domNode.nativeElement.getElementsByClassName('record-meta selected');
    if (elements.length === 0) {
      window.requestAnimationFrame(() => {
        this.ScrollToView();
      });
      return;
    }
    elements[0].scrollIntoView()

  }
  IsSelection(feature: any) {
    if (!feature?.partId) return false;
    return this.selectedFeature?.routePart.id === feature.partId;
  }
  FormatId(feature: any, index: number): string {
    return `${this.routeName}`;
  }
  FormatPath(pathEnd: string, parentFeatureId?: ObjID) {
    const parent = (!!parentFeatureId) ? this.dataMgr.GetProject()?.idRegistry.Get(parentFeatureId) : undefined;
    let path = pathEnd;
    if (!!parent) {
      path = parent.name + ':' + path;
      if (!!parent.parent) {
        path = this.FormatPath(path, parent.parent);
      }
    }
    return path;
  }
  JumpTo(feature: any) {
    const type = feature.type;
    if (!type) return;
    const map = this.dataMgr.GetProject()?.drawPane?.map?.ui;
    if (!map) return;
    switch (type) {
      case 'point':
        map.jumpTo({ center: { lng: feature.coord.spatial.lng, lat: feature.coord.spatial.lat } });
        return;
      case 'segment':
        const from = feature.from.coord.spatial as SpatialCoord;
        const to = feature.to.coord.spatial as SpatialCoord;
        const bounds = new LngLatBounds();
        const nE = { lng: Math.max(from.lng, to.lng), lat: Math.min(from.lat, to.lat) };
        const sw = { lng: Math.min(from.lng, to.lng), lat: Math.max(from.lat, to.lat) };
        map.fitBounds(new LngLatBounds(nE, sw), { zoom: map.getZoom() });
    }
    // center map on feature
  }
  Select(feature: ObjID) {
    // select feature
  }
  Edit(feature: ObjID) {
    // send feature to editor
  }
  FormatGeomType(feature: any): '' | 'point' | 'segment' {
    if (!feature) return '';
    return feature.type;
  }
  FormatRouteName(feature: any): string {
    if (!feature) return '';
    const featureRoute = this.dataMgr.GetProject()?.idRegistry.Get(feature.featureId) as Route;
    return featureRoute.name;
  }
  FormatFeatureName(feature: any): string {
    if (!feature) return '';
    const info = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!info) return '';
    switch (info.type) {
      case 'point':
        return info.data.pointName;
      case 'segment':
        return info.data.segmentName;
    }
    return feature.data.name;
  }
  FormatType(feature: any): string {
    if (!feature) return '';
    // get feature and return attribute label for feature's type
    const info = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!info) return '';
    switch (info.type) {
      case 'point':
        if (!info.data?.pointType) return '';
        return this.dataMgr.GetProject()?.idRegistry.Get(info.data.pointType).label;
      case 'segment':
        if (!info.data?.segmentType) return '';
        return this.dataMgr.GetProject()?.idRegistry.Get(info.data.segmentType).label;
    }
    return '';
  }
  private _laborKey?: ObjID;
  private _materialsKey?: ObjID;

  FormatLaborTotals(feature: any): string {
    // get feature and return attribute label for feature's type
    const info = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!info) return '';
    if (!info.costTally.labor) return '$0.00';
    return info.costTally!.labor ? this.FormatDollars(info.costTally.labor) : '$0.00';
  }
  FormatMaterialsTotals(feature: any): string {
    // get feature and return attribute label for feature's type
    const info = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!info) return '';
    if (!info!.costTally?.materials) return '$0.00';
    return info.costTally!.materials ? this.FormatDollars(info.costTally.materials) : '0.00';

  }
  FormatLength(feature: any): string {
    if (!feature) return '';
    if (feature.type === 'segment') {
      if (!feature.length) return '';
      return this.Format(feature.length, '', 'feet', 0, 'normal');
    }
    // return the feature's length if a line or 'n/a' for a point
    return 'n/a';
  }
  FormatTotalCost(feature: any): string {
    // get the cost tally for the feature
    const info = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!info) return '';
    if (!info?.value) return '';
    return this.FormatDollars(info.value);
  }

  GetFeatureData(feature: any): Array<FeatureDatum> {
    // return data for feature
    const info = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!info) return [];
    let data = [];
    const attributeOrder = this.dataMgr.GetProject()?.GetAttributeOrder(feature.type);
    if (!attributeOrder) return [];
    for (const attribute of attributeOrder) {
      if (info.data.hasOwnProperty(attribute) === false) continue;
      data.push({ id: attribute, value: info.data[attribute] });
    }
    return data;
  }
  IsDisplayableAttribute(featureItem: FeatureDatum): boolean {
    // get attribute
    // if it is a select attribute and it's name starts with "select"
    // or we know it is an equivalent ofa  select a ... entry then false
    // if there are no costs
    // if text with no value and no costs then false
    // if checkbox that is false with no costs then false
    if (this.FormatAttributeName(featureItem) === 'Name') return false;
    return this.GetAttributeValue(featureItem) !== '';
    return true;
  }

  FormatAttributeName(info: any): string {
    // return the name/label for the attribute
    const attribute = this.dataMgr.GetProject()?.GetAttributeById(info.id);
    if (!attribute) return '';

    return attribute.label;

  }
  GetAttributeValueDisplayble(info: any): boolean {
    const attribute = this.dataMgr.GetProject()?.GetAttributeById(info.id);
    if (!attribute) return false;
    switch (attribute.input) {
      case 'checkbox':
        return true;
      case 'input':
        if (info.value === '') return false;
        return true;
      case 'qty':
        if (info.value === '') return false;
        return true;
      case 'selector':
        const value = this.dataMgr.GetProject()?.idRegistry.Get(info.value);
        if (!value) return false;
        if (value.label.toLowerCase().trim().indexOf('select') === 0) return false;
        return true;
    }
    return false;
  }
  GetAttributeValue(info: any): string {
    // return attribute value as string
    // for boolean display true or false
    // for text display text
    // for select get the label to for selected item
    const attribute = this.dataMgr.GetProject()?.GetAttributeById(info.id);
    if (!attribute) return '';
    switch (attribute.input) {
      case 'checkbox':
        return info.value;
      case 'input':
        return info.value;
      case 'qty':
        return info.value;
      case 'selector':
        const value = this.dataMgr.GetProject()?.idRegistry.Get(info.value);
        if (!value) return '';
        if (value.label.toLowerCase().trim().indexOf('select') === 0) return '';
        return value.label;
    }
    return '';
  }
  GetAttributeHasCosts(featureItem: FeatureDatum, feature: any): boolean {
    if (this.FormatAttributeTotal(featureItem, feature) === '') return false;
    if (!feature.partId) return false;
    const part = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!part) return false;
    const attributeTally = this.GetAttributeTally(part.tally, featureItem);
    return !!attributeTally;

  }
  GetAttributeHasCost(featureItem: FeatureDatum, cost: 'labor' | 'materials', feature: any): boolean {
    return this.FormatAttributeCost(featureItem, cost, feature) !== '';
  }
  FormatAttributeCost(featureItem: FeatureDatum, cost: 'labor' | 'materials', feature: any): string {
    if (!feature.partId) return '';

    const attribute = this.dataMgr.GetProject()?.idRegistry.Get(featureItem.id);
    const part = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!part) return '';
    const attributeTally = this.GetAttributeTally(part.tally, featureItem);
    if (!attributeTally?.costs?.hasOwnProperty(cost)) return '';
    return '' + this.FormatDollars(attributeTally.costs[cost]);

  }
  FormatAttributeTotal(featureItem: FeatureDatum, feature: any): string {
    if (!feature.partId) return '';
    const attribute = this.dataMgr.GetProject()?.idRegistry.Get(featureItem.id);
    const part = this.dataMgr.GetProject()?.idRegistry.Get(feature.partId);
    if (!part) return '';
    const attributeTally = this.GetAttributeTally(part.tally, featureItem);
    if (!attributeTally?.total) return '';
    return this.FormatDollars(attributeTally.total);
  }
  GetAttributeTally(tally: any, featureItem: FeatureDatum) {
    const attribute = this.dataMgr.GetProject()!.idRegistry.Get(featureItem.id);
    return (attribute.input === 'selector') ? tally[featureItem.value] : tally[featureItem.id];
  }

  FormatDollars(val: any) {
    return this.Format(val, '$', '', 2);
  }
  Format(val: any, prefix: string = '', units = '', fixed = 2, round: 'normal' | 'down' | 'up' = 'normal') {
    let str = '' + val;
    if (val === undefined) return '';
    if (val === 0) return '';
    if (val === '') return '';
    const dollarAndCents = str.split('.');
    if (fixed === 0) {
      switch (round) {
        case 'up':
          val = Math.ceil(val);
          break;
        case 'down':
          val = Math.floor(val);
          break;
        default:
          val = Math.round(val);
      }
    }
    str = prefix + String(dollarAndCents[0]).replace(/(.)(?=(\d{3})+$)/g, '$1' + ',');
    if (fixed !== 0) {
      str += dollarAndCents.length === 1 ? '.' + Number('.00').toFixed(fixed).split('.').pop() : '.' + Number('.' + dollarAndCents[1]).toFixed(fixed).split('.').pop();
    }
    str += ' ' + units;
    return str;
  }
  SelectRecord(feature: any, internal: boolean = false) {
    // if (!this.route) return;
    this._suppressJump = internal;
    (this.route?.feature as any).Select(feature.id, this.route?.id);
    // this.dataMgr.SelectFeature(feature.id,route);
  }
  UpdateMode(mode?: SubMode) {
    const oldMode = this.mode;
    if (!!mode) {
      if (this.mode === '<*>') {
        return;
      }
      this.mode = mode;
      if (oldMode !== this.mode) {
        if (!this._route) return;
        this.features = this.MakeReport();
        this.featuresChange.emit(this.features);

      }
      this.Refresh();

      return;
    }
    this.mode = this.route?.expanded ? '*' : '*+';
    if (oldMode !== this.mode) {
      if (!this._route) return;
      this.features = this.MakeReport();//this._route, this.mode);
      this.featuresChange.emit(this.features);

    }
  }
  IsNodeIncluded(feature: any) {
    return true;

    if (!this.route) return false;
    /*
    if (this.IsPointInCommon(feature)) {

      let invisCount = 0;
      let notThis = 0;
      if (feature.featureId === this.route!.id) return true;
      for (const routeId of feature.routes) {
        const route = this.dataMgr.GetProject()?.idRegistry.Get(routeId) as Route;
        if (route.id === this.route!.id) continue;
        notThis += 1;
        if (route.feature.visible === false) {
          invisCount += 1;
        }
      }
      if (notThis && invisCount) {
        return (invisCount === notThis);
      }

    }
    return true;
    */
  }
  Refresh() {
    if (!this._ready) return;
    this.cdr.detectChanges();
  }

}
